export default "__VITE_ASSET__53c68a92__"